export default __webpack_public_path__ + "static/media/placeholder.d0de29d6.png";